import { useState, useCallback } from 'react'

export function useToast() {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((message, type = 'success', duration = 3000) => {
    const id = Date.now() + Math.random()
    setToasts((prev) => [...prev, { id, message, type, duration }])
  }, [])

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  const success = useCallback((message, duration) => {
    addToast(message, 'success', duration)
  }, [addToast])

  const error = useCallback((message, duration) => {
    addToast(message, 'error', duration)
  }, [addToast])

  const info = useCallback((message, duration) => {
    addToast(message, 'info', duration)
  }, [addToast])

  const warning = useCallback((message, duration) => {
    addToast(message, 'warning', duration)
  }, [addToast])

  return {
    toasts,
    removeToast,
    success,
    error,
    info,
    warning
  }
}
